import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import {
  Section,
  Container,
  WhiteSquare,
  SquareTitle,
  Content,
} from '../styles/SharedBlockStyledComponents';

export default function BlockAlgorithmHardcoded() {
  return (
    <>
      <Section className="relative mt-16">
        <Container>
          {/* bg photo */}
          <StaticImage
            src="../images/algo-bg-01.png"
            alt="Background"
            className="bg--photo"
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              height: '100%',
              zIndex: 1,
            }}
            placeholder="none"
            layout="fullWidth"
          />

          <Content className="algorithm-hero">
            <h1 className="h1">We found a better way</h1>
            <WhiteSquare className="left">
              <SquareTitle>
                Our algorithm leads the industry in speed, adaptability and
                fleet-wide efficiency at scale.
              </SquareTitle>
            </WhiteSquare>
          </Content>
        </Container>
      </Section>

      <Section className="relative">
        <Container>
          {/* bg photo */}
          <StaticImage
            src="../images/algo-bg-02.png"
            alt="Background"
            className="bg--photo"
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              height: '100%',
              zIndex: 1,
            }}
            placeholder="none"
            layout="fullWidth"
          />

          {/* show content */}
          <Content className="algorithm-analytics" $maxWidth="1120px">
            <h2>
              Road-tested algorithm
            </h2>
            <p>
              <span className="percent">5M+ </span> trips across 50+ global deployments
            </p>
            <p>
              <span className="percent">20+</span> peak passengers per vehicle revenue hour
            </p>
            <p className="last">
              <span className="percent">3-8x</span> higher seat utilization than alternative software
            </p>
            <WhiteSquare className="right mt-16">
              <SquareTitle>
                <div className="mt-4" style={{ fontWeight: 'normal' }}>
                  We’d love to run your data and see how we measure up. 
                </div>
              </SquareTitle>
              <Link
                to="/contact"
                className="btn--rounded bg--tan"
                style={{
                  color: `var(--color-text)`,
                  transform: `translateX(90px)`,
                }}
              >
                Book a demo
              </Link>
            </WhiteSquare>
          </Content>
        </Container>
      </Section>

      <Section className="relative">
        <Container>
          <StaticImage
            src="../images/algo-bg-03.png"
            alt="Background"
            className="bg--photo left"
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-100%)',
              width: '50%',
              height: '100%',
              zIndex: 1,
            }}
            placeholder="none"
            layout="fullWidth"
          />
          <Content className="algorithm-page-graphic-right">
            <h2 className="h2">More trips with fewer vehicles</h2>
            <p className="mt-12">
              Keep your fleet occupied and on the move without pushing back ETAs. 
            </p>
          </Content>
        </Container>
      </Section>

      <Section className="relative">
        <Container>
          <StaticImage
            src="../images/algo-bg-04.png"
            alt="Background"
            className="bg--photo"
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              height: '100%',
              zIndex: 1,
            }}
            placeholder="none"
            layout="fullWidth"
          />
          <Content className="algorithm-does-it-all">
            <h2>
              Batch on-demand, scheduled, shared, and solo&nbsp;trips at scale
            </h2>
            <p className="right mt-8">(Other algorithms don't do that)</p>
          </Content>
        </Container>
      </Section>

      <Section className="relative">
        <Container>
          <StaticImage
            src="../images/algo-bg-05.png"
            alt="Background"
            className="bg--photo left"
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-100%)',
              width: '50%',
              height: '100%',
              zIndex: 1,
            }}
            placeholder="none"
            layout="fullWidth"
          />
          <Content className="algorithm-page-graphic-right">
            <h2 className="h2">Customization without compromise</h2>
            <p className="mt-12">
              Our routing algorithm reoptimizes every 15 seconds based on whatever rules you set.
            </p>
          </Content>
        </Container>
      </Section>

      {/* <Section className="relative">
        <Container>
          <div
          TODO: Optimize this image  // 
          className="bg--photo"
            style={{ background: `url(${bgSix}) no-repeat` }}
          />
          <Content style={{ top: `45%` }}>
            <CTAText style={{ fontSize: `3rem`, lineHeight: `3.5rem` }}>
              Yes, it does scale.
            </CTAText>
          </Content>
        </Container>
      </Section> */}

      <Section
        className="relative"
        style={{ backgroundColor: 'var(--color-primary)', maxHeight: '589px' }}
      >
        <Container>
          <Content className="algorithm-license-contact">
            <div className="algorithm-license-contact-left">
              <h2 className="h2">
                License our technology to optimize your fleet operations
              </h2>
              <Link
                to="/contact"
                className="btn--rounded bg--tan mt-8"
                style={{ width: 'fit-content' }}
              >
                Talk to us
              </Link>
            </div>
            <div className="algorithm-license-contact-right">
              <h3>Transit systems</h3>
              <h3>Autonomous vehicles</h3>
              <h3>On-demand ride platforms</h3>
              <h3>Shipping and delivery</h3>
              {/* Lord forgive me for the sins I hath done, for the links of which hath been copied */}
              <Link
                to="/contact"
                className="btn--rounded bg--tan mt-8"
                style={{ width: 'fit-content' }}
              >
                Talk to us
              </Link>
            </div>
          </Content>
        </Container>
      </Section>
    </>
  );
}
